import { ButtonReset } from '@helpers/global';
import { between, Device } from '@helpers/media';
import DotPaginationStyles from '@stories/Components/Global/DotPagination/DotPagination.styles';
import SvgHexOutline from '@img/icons/hexagon_outline.svg';
import styled from 'styled-components';
import brand from '@helpers/brand';
const Container = styled.nav `
  display: flex;
  gap: 16px;
  padding: 4px 0;
  place-content: center;
  place-items: center;

  &[data-show-progress='true'] {
    width: 100%;
    max-width: 500px;
  }

  &[data-item-amount='true'] {
    @media ${between(Device.MobileLarge, Device.Tablet)} {
      ${DotPaginationStyles.Container} {
        display: none;
      }
    }
  }
`;
const ButtonOutline = styled(SvgHexOutline) `
  color: ${brand.black};
`;
const Button = styled.button `
  ${ButtonReset}
  display: flex;
  border-radius: 50%;
  width: 53px;
  height: 48px;
  place-content: center;
  place-items: center;
  position: relative;

  svg {
    display: block;
    height: 18px;
    width: 28px;
    position: relative;
  }

  ${ButtonOutline} {
    position: absolute;
    width: 53px;
    height: 48px;
  }

  &:disabled {
    opacity: 0.5;
  }

  &:not(:disabled) {
    &:focus,
    &:hover {
      svg {
        color: ${brand.secondary.red3};
      }
    }
  }
`;
const ButtonArea = styled.div `
  position: relative;
  height: 72px;
  width: 100px;
  flex: 0 0 100px;

  ${Button}:first-child {
    position: absolute;
    top: 0;
    left: 0;
  }

  ${Button}:last-child {
    position: absolute;
    bottom: 0;
    right: 0;
  }

`;
const ControlsStyles = {
    Button,
    ButtonArea,
    ButtonOutline,
    Container,
};
export default ControlsStyles;
